type LegalPage = "support" | "privacy" | "copyright";

const pageLinks = [
  {
    key: "support",
    href: "/support",
    label: "App Support",
  },
  {
    key: "privacy",
    href: "/privacy",
    label: "Privacy Policy",
  },
  {
    key: "copyright",
    href: "/copyright",
    label: "Copyright",
  },
] as const;

interface LegalPageLinksProps {
  current: LegalPage;
}

const LegalPageLinks = ({ current }: LegalPageLinksProps) => {
  return (
    <div className="mt-8 flex flex-wrap gap-3">
      {pageLinks.map((link) => {
        const isCurrent = link.key === current;

        return (
          <a
            key={link.key}
            href={link.href}
            className={`rounded-full px-4 py-2 text-sm font-semibold tracking-[0.12em] transition ${
              isCurrent
                ? "bg-white text-tcc-blue shadow-md"
                : "border border-white/20 bg-white/10 text-white/90 backdrop-blur-sm hover:border-white/40 hover:bg-white/15"
            }`}
          >
            {link.label}
          </a>
        );
      })}
    </div>
  );
};

export default LegalPageLinks;
